import { errorHandler } from 'pobble-components/dist/error-handler'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { apiCreateWork } from '../common/api/pupil-activity'
import { apiCreateMedium, apiDeleteWork } from '../common/api/work'

export const useWorkUpload = () => {
  const [uploadingWork, setUploadingWork] = useState(false)
  const history = useHistory()

  const uploadWork = (pupilId, files) => {
    setUploadingWork(true)
    return apiCreateWork(pupilId, { image: files[0] })
      .then(res => {
        if (files.length > 1) {
          return Promise.all(
            files.slice(1, files.length).map(file => {
              return apiCreateMedium(res.data.work.id, {
                image: file
              })
            })
          )
            .then(() => {
              setUploadingWork(false)
              history.push(`/work/${res.data.work.id}`)
            })
            .catch(e => {
              setUploadingWork(false)
              if (e.response.status === 400) {
                apiDeleteWork(res.data.work.id)
              }
              errorHandler(e)
            })
        } else {
          setUploadingWork(false)
          history.push(`/work/${res.data.work.id}`)
        }
      })
      .catch(e => {
        setUploadingWork(false)
        errorHandler(e)
      })
  }

  return {
    uploadingWork,
    uploadWork
  }
}
